import { openCrispSupport } from './crispService'

const TELEGRAM_SUPPORT_BOT_URL = 'https://t.me/skinoz_support_bot'
const SUPPORT_CHANNEL = (import.meta.env.VITE_SUPPORT_CHANNEL || 'telegram').toLowerCase()

const isCrispMode = SUPPORT_CHANNEL === 'crisp'

export const isCrispSupportEnabled = () => isCrispMode

export const getSupportChannel = () => (isCrispMode ? 'crisp' : 'telegram')

export const openSupport = (playerId = null) => {
  if (isCrispMode) {
    openCrispSupport(playerId)
    return
  }

  const tg = window.Telegram?.WebApp
  if (tg?.openLink) {
    tg.openLink(TELEGRAM_SUPPORT_BOT_URL)
    return
  }

  window.open(TELEGRAM_SUPPORT_BOT_URL, '_blank', 'noopener,noreferrer')
}
